import { useEffect } from "react"

interface UseKeyboardShortcutsProps {
  quickLayers: string[]
  toggleLayer: (id: string) => void
  setLayersOpen: React.Dispatch<React.SetStateAction<boolean>>
  setShortcutsOpen: React.Dispatch<React.SetStateAction<boolean>>
  onEscape?: () => void
}

export const useKeyboardShortcuts = (props: UseKeyboardShortcutsProps) => {
  const { quickLayers, toggleLayer, setLayersOpen, setShortcutsOpen, onEscape } = props

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      const tag = (document.activeElement as HTMLElement)?.tagName
      const isInput = tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT"

      if (e.key === "Escape") {
        onEscape?.()
        if (isInput) (document.activeElement as HTMLElement).blur()
        return
      }

      if ((e.key === "l" || e.key === "L") && !isInput) {
        setLayersOpen((prev) => !prev)
        e.preventDefault()
        return
      }

      if (isInput) return

      if (e.key === "/") {
        const el = document.querySelector("[data-address-search]") as HTMLInputElement
        if (el) {
          el.focus()
          el.select()
        }
        e.preventDefault()
        return
      }

      if (e.key === "c" || e.key === "C") {
        const el = document.querySelector("[data-commune-search]") as HTMLInputElement
        if (el) {
          el.focus()
          el.select()
        }
        e.preventDefault()
        return
      }

      if (e.key === "p" || e.key === "P") {
        const el = document.querySelector("[data-parcel-search]") as HTMLInputElement
        if (el) {
          el.focus()
          el.select()
        }
        e.preventDefault()
        return
      }

      if (e.key === "?") {
        setShortcutsOpen((prev) => !prev)
        e.preventDefault()
        return
      }

      const quickIndex = parseInt(e.key, 10)
      if (quickIndex >= 1 && quickIndex <= quickLayers.length && quickIndex <= 9) {
        toggleLayer(quickLayers[quickIndex - 1])
        e.preventDefault()
      }
    }

    window.addEventListener("keydown", handler)
    return () => window.removeEventListener("keydown", handler)
  }, [quickLayers, toggleLayer, setLayersOpen, setShortcutsOpen, onEscape])
}
